// BonBoZ: NHẤN GIỮ để mở menu ngữ cảnh trên màn cảm ứng.
//
// Menu "Trả lời / Sao chép / Dịch / Xoá" của tin nhắn và menu "Gán nhân viên /
// Gắn nhãn / Xoá" của thẻ hội thoại đều chỉ mở bằng sự kiện `contextmenu`.
// Android Chrome có bắn sự kiện đó khi giữ lâu, nhưng **iOS Safari thì không** —
// nên trên iPhone những thao tác đó không với tới được bằng cách nào cả.
//
// Nút ba chấm thì không cứu được: nó là `invisible group-hover:visible`, mà màn
// cảm ứng không rê chuột được; riêng ở tin nhắn nó còn bị `hide-button` bỏ hẳn.
//
// Chỗ này bù bằng tay: giữ 500ms thì gọi đúng hàm mà `contextmenu` vẫn gọi.
import { ref } from 'vue';

const NGUONG_DI_CHUYEN = 10; // px — quá mức này coi như đang cuộn, không phải giữ
const THOI_GIAN_GIU = 500; // ms — bằng ngưỡng long-press quen thuộc của iOS

export function useNhanGiu(khiGiuLau, thoiGian = THOI_GIAN_GIU) {
  let hen = null;
  let diemDau = null;

  // Cú `click` luôn nổ sau `touchend`, kể cả khi vừa giữ lâu. Không có cờ này
  // thì một lần giữ vừa mở menu vừa kích hoạt hành động của cú bấm thường —
  // ở thẻ hội thoại là mở luôn hội thoại, ở bong bóng là bật chú thích giờ.
  const vuaGiuLau = ref(false);

  // Ngón tay đã trượt quá ngưỡng, tức là người dùng đang CUỘN chứ không bấm.
  //
  // Trình duyệt vẫn bắn `click` sau một cú vuốt ngắn — nó chỉ nén `click` khi
  // vuốt đủ dài để nhận ra là cử chỉ cuộn. Vuốt ngắn trong danh sách hội thoại
  // thì lọt qua, và người trực mở nhầm hội thoại liên tục (báo lỗi 22/09/2026).
  const vuaCuon = ref(false);

  const huy = () => {
    if (hen) {
      clearTimeout(hen);
      hen = null;
    }
    diemDau = null;
  };

  const batDau = su => {
    const cham = su.touches?.[0];
    if (!cham) return;

    // `huy()` phải chạy TRƯỚC khi ghi `diemDau`, vì chính nó xoá `diemDau` về
    // `null`. Trước đây hai dòng này ngược nhau nên mỗi lần chạm là điểm gốc bị
    // xoá ngay, `diChuyen` không có gì để so, và ngưỡng 10px chưa bao giờ chạy —
    // cuộn qua một thẻ hội thoại 500ms là menu ngữ cảnh bật lên.
    huy();

    // Chạm mới thì xoá dấu vết lần trước, nếu không một lần cuộn sẽ nuốt luôn
    // cú bấm ngay sau đó.
    vuaCuon.value = false;
    diemDau = { x: cham.clientX, y: cham.clientY };
    hen = setTimeout(() => {
      hen = null;
      vuaGiuLau.value = true;
      // Dựng một sự kiện giả mang đủ thứ mà hàm mở menu cần: nó đọc
      // `pageX/clientX`, `target` và gọi `preventDefault()`.
      khiGiuLau({
        type: 'longpress',
        target: su.target,
        pageX: cham.pageX,
        pageY: cham.pageY,
        clientX: cham.clientX,
        clientY: cham.clientY,
        preventDefault: () => {},
      });
    }, thoiGian);
  };

  const diChuyen = su => {
    const cham = su.touches?.[0];
    if (!cham || !diemDau) return;
    if (
      Math.abs(cham.clientX - diemDau.x) > NGUONG_DI_CHUYEN ||
      Math.abs(cham.clientY - diemDau.y) > NGUONG_DI_CHUYEN
    ) {
      vuaCuon.value = true;
      huy();
    }
  };

  /**
   * Gọi đầu mỗi handler `click`: trả `true` nghĩa là cú bấm này phải bỏ qua.
   *
   * Hai trường hợp phải bỏ: vừa giữ lâu (menu đã mở rồi), và vừa cuộn (ngón tay
   * trượt quá ngưỡng nên đây không phải ý định bấm).
   */
  const boQuaCuBam = () => {
    const bo = vuaGiuLau.value || vuaCuon.value;
    vuaGiuLau.value = false;
    vuaCuon.value = false;
    return bo;
  };

  return { batDau, diChuyen, huy, boQuaCuBam };
}
